let state = {
    device: {},
    session: {},
    posts: [],
    token: localStorage.getItem('token'),
}
export default state
